function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4C0 1.79086 1.79086 0 4 0H60C62.2091 0 64 1.79086 64 4V39C64 41.2091 62.2091 43 60 43H4C1.79086 43 0 41.2091 0 39V4Z",
  fill: "#01326F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7448 10.887H25.9337V32.1133H37.7448V10.887Z",
  fill: "#FF5F00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6836 21.5024C26.6814 19.4579 27.1445 17.4396 28.0377 15.6005C28.9309 13.7614 30.2309 12.1497 31.8392 10.8874C29.8479 9.32239 27.4564 8.34921 24.9381 8.07908C22.4199 7.80895 19.8764 8.25275 17.5984 9.35977C15.3205 10.4668 13.3999 12.1924 12.0562 14.3393C10.7126 16.4862 10 18.9678 10 21.5005C10 24.0332 10.7126 26.5149 12.0562 28.6618C13.3999 30.8087 15.3205 32.5342 17.5984 33.6413C19.8764 34.7483 22.4199 35.1921 24.9381 34.922C27.4564 34.6518 29.8479 33.6786 31.8392 32.1137C30.2314 30.8517 28.9317 29.2406 28.0385 27.4022C27.1453 25.5638 26.682 23.5463 26.6836 21.5024Z",
  fill: "#EB001B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M53.6804 21.5019C53.6804 24.0348 52.9677 26.5166 51.6238 28.6635C50.2798 30.8105 48.359 32.5361 46.0807 33.6429C43.8025 34.7498 41.2587 35.1933 38.7403 34.9228C36.2219 34.6523 33.8304 33.6786 31.8392 32.1131C33.4464 30.8501 34.7457 29.2385 35.6392 27.4C36.5326 25.5615 36.9969 23.5441 36.9969 21.5C36.9969 19.4559 36.5326 17.4385 35.6392 15.6C34.7457 13.7615 33.4464 12.1499 31.8392 10.8869C33.8304 9.32138 36.2219 8.34774 38.7403 8.07722C41.2587 7.80669 43.8025 8.25021 46.0807 9.35707C48.359 10.4639 50.2798 12.1895 51.6238 14.3365C52.9677 16.4834 53.6804 18.9652 53.6804 21.4981V21.5019Z",
  fill: "#F79E1B"
});

function SvgMastercardMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 43,
    viewBox: "0 0 64 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardMedium);
export default __webpack_public_path__ + "static/media/mastercard-medium.204411a8.svg";
export { ForwardRef as ReactComponent };